export const LARGE_DESKTOP_SCREEN = '1920px';
export const SMALL_DESKTOP_SCREEN = '1366px';
export const LARGE_MOBILE_SCREEN = '768px';
